import { PortalHelper } from "@/Common/Helpers/PortalHelper";
import { DocumentSortOrderType, DocumentUIState, SortDirection } from "@/Common/Models/UI/Enums";
import { IJDocumentCreateEditUIModel } from "@/Documents/Models/JSONInterfaces/IJDocumentCreateEditUIModel";
import { IJDocumentsTabModel } from "@/Documents/Models/JSONInterfaces/IJDocumentsTabModel";
import { MedicalDocumentItem, MedicalDocumentItemDto } from "@/Documents/Models/Medical/MedicalDocumentItem";

class DocumentsHelper {
    public static DefaultModelForDocumentsModel(orderBy: DocumentSortOrderType = DocumentSortOrderType.AttachedOnDate): IJDocumentsTabModel {
        var m: IJDocumentsTabModel = {
            DocumentTableColumnDefinitions: [],
            SelectedDisplayedColumn: null,
            SelectedAvailableColumn: null,
            DisplayedColumns: [],
            ColumnOrderingPopupOpen: false,
            UpdatedTableColumn: null,
            DocumentNonApprovedAndUrgentCount: 0,
            DocumentSearchBreadCrumbTitle: cacheStore.GetString("AllDocumentsLabel"),
            DocumentNonApprovedCount: 0,
            TotalQueryPages: 0,
            TotalQueryRows: 0,
            CurrentPage: 1,
            SearchOptionsOpen: false,
            SearchString: "",
            SearchResultsSortColumn: orderBy,
            SearchResultsSortColumnDirection: SortDirection.DESC,
            SearchResultsColumnOrder: [],
            PageSizeOptions: [30, 50, 100],
            SelectedPageSizeOption: 50,
            SelectedPageNumber: 1,
            GlobalDocumentSearchText: "",
            DocumentsSearchContainerId: "doc_settings_container",
            SelectAllSitesChecked: null,
            SelectAllCliniciansChecked: null,
            SelectAllStatusChecked: null,
            SelectAllUrgencyChecked: null,
            CliniciansGlobalCache: [],
            CliniciansFiltered: [],
            Sites: [],
            SelectedDocumentId: null,
            SelectedDocumentClass: null,
            SelectedDocumentSubclass: null,
            MyleTableConfig: null,
            CurrentDocumentNotes: [],
            CurrentAttachements: [],
            CurrentDocumentIDForNotes: "",
            CurrentDocumentNoteValue: "",
            DocumentsTableData: [],
            CliniciansSearchText: "",
            Documents: [],
            Status: [],
            Urgency: [],
            DateFrom: null,
            DateTo: null,
            SelectedDocument: null,
            NewDocument: null,
            UIState: DocumentUIState.Search,
            DocumentClasses: { "": [] },
            DocumentSources: [],
            DocumentDescription: [],
            BeginUpload: false,
            NotesDropdownControlId: "notes_dropdown_main",
            NoteWindowOpen: false,
            MulitFilePopupOpen: false,
            TopPosition: -99999,
            LeftPosition: -99999,
            // CreatedDocumentMetadata: null,
            TargetElement: null,
            LeftMenuOpen: true,
            PatientContactId: "",
            Initialized: false,
            IsFromPatient: false,
            IsLoadingFromServer: false,
            SelectAllSentByChecked: null,
            SelectAllPortalStatus: null,
            SentByGlobalCache: [],
            SentByFiltered: [],
            SentBySearchText: "",
            PortalLinkedItemModel: Immutable.fromJS(PortalHelper.getDefaultPortalLinkedItemModel()),
            IsSendToPatientPortalPopupOpen: false,
            ShowOnlySelectedSites: null,
            PortalStatuses: [],
            SelectedView: "allDocuments"
        };

        return m;
    }

    public static DefaultModelForDocumentCreateEditUIModel(): IJDocumentCreateEditUIModel {
        var m: IJDocumentCreateEditUIModel = {
            AdditionalDetailsVisible: false,
            Clinicians: [],
            SelectedClinicians: [],
            SelectedPatients: [],
            DetailsLinkLabel: "Add Details",
            DetailsLinkImagePath: rootPath + "/content/images/icons/documents/add_details.png",
            Note: "",
            Source: "",
            Description: "",
            AccompanyingMnemonic: "",
            AccompanyingSubClass: "",
            SourceAuthorName: "",
            SendingFacilityId: "",
            SendingFacilityReport: "",
            ClassLookupId: "",
            SubClassLookupId: "",
            Site: "",
            HRMStatusList: [],
            SelectedHRMStatus: "",
            NumberOfFiles: 0,
            LockUI: false,
            MedicalDocumentInfo: new MedicalDocumentItem(new MedicalDocumentItemDto()),
            DocumentDate: null,
            AuthoringDate: null,
            ObservationDate: null,
            IsUrgent: false,
            SignOffDate: null,
            SignOffByContactId: "",
            LastModifiedBy: "",
            LastModifiedByDate: null,
            ShowNoteCreateForm: false,
            RememberClinician: false,
            RememberDescription: false,
            HasBatchScan: false,
            StartNewPojectPopup: false,
            BatchScanPopupOpen: false,
            FileToBigErrorPopup: false,
            PleaseWaitPopup: false,
            ListOfImagePath: [],
            ImageBase64List: [],
            HideBatchScanAndAttachButton: false,
            SelectedPageArray: [],
            DeleteWarningPopup: false,
            CompleteBatchScan: false,
            FailUploadModal: false
        };

        return m;
    }

    public static GetDocumentStatusLabel(medicalNote: MedicalDocumentItemDto): string {
        if (cacheStore.ClinicSettings.EnableApprovedByColleagueDocumentStatus) {
            return cacheStore.GetString(medicalNote.DocumentStatusVocabularyKey);
        }
        const isAnnotationEnabled: boolean = cacheStore.ClinicSettings.EnableDocumentInAppView;

        let documentStatusKey: string;
        if (medicalNote.SignOffDate && medicalNote.SignOffByContactId)
            documentStatusKey = "ApprovedLabel";
        else if (medicalNote.IsAnnotated && isAnnotationEnabled)
            documentStatusKey = "AnnotatedLabel";
        else
            documentStatusKey = "NotApprovedLabel";

        return cacheStore.GetString(documentStatusKey);
    }
}

export { DocumentsHelper };
